/*
 * @Author: Jankerli
 * @Date:   2018-08-08 09:10:50
 * @Last Modified by:   Jankerli
 * @Last Modified time: 2019-01-24 15:36:04
 *
 * M 站上报
 */

import Utils from '@/utils/utils'
import $ from 'jquery'

let url_pv = 'https://pcweb-v1.log.mgtv.com/dispatcher.do'

var m_cookie = Utils.getCookie('m_cookie')

if (!m_cookie) {
  m_cookie = Utils.uuid()

  Utils.setCookie('m_cookie', m_cookie)
}

// pv 上报公共参数
function _pvCommParams() {
  return {
    time: Utils.getYMDHMS(),
    suuid: Utils.uuid(),
    url: encodeURIComponent(location.href),
    cookie: m_cookie,
    uuid: (window.userInfo && window.userInfo.uuid) || '',
    ch: '90fd9ghct',
    ref: document.referrer || '',
    from: /iphone/.test(navigator.userAgent.toLowerCase())
      ? 'iphone'
      : 'android',
    bid: '4.1.2',
    act: 'pv',
    sessionid: Utils.uuid(),
    abroad: 0,
    istc: '',
    ac: '',
    dc: '',
  }
}

export default {
  pv(params, callback) {
    let img = new Image()
    img.src = url_pv + '?' + Utils.toParam($.extend(_pvCommParams(), params))

    img.onload = () => {
      img = null

      callback && callback()
    }

    img.onerror = () => {
      img = null

      callback && callback()
    }
  },
}
